<template>
  <div class="container">
    <div ref="bgDom" class="bgimg" :style="{ height: nowHeight }">
      <!-- <img src="../../assets/Login/bg_Sign.png" alt="" /> -->
      <div class="indexs">
        <div class="xian"></div>
        <div class="downloads">
          <img src="../../assets/admin_login/logo.png" alt="" />
          <img :src="downloadUrl || redownloadUrl" alt="" />
          <span>扫码下载授课通APP</span>
        </div>
        <div class="login">
          <div class="header">
            <div @click="userLog" ref="userLog">账号登录</div>
            <div @click="scanLog" ref="scanLog">扫码登录</div>
          </div>
          <!-- 账号登录 -->
          <div class="accountLogin" v-if="logFlag">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
              <el-form-item prop="username">
                <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="账号 Username"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input type="password" v-model="form.password" placeholder="密码 Password"
                  prefix-icon="el-icon-unlock"></el-input>
              </el-form-item>
              <!-- <el-form-item prop="yzm">
                <div class="code">
                  <el-input
                    class="codeInput"
                    v-model="form.yzm"
                    placeholder="请输入验证码"
                  ></el-input>
                  <random class="codes" :identifyCode="identifyCode"></random>
                </div>
              </el-form-item> -->
              <div class="protocol">
                <el-checkbox v-model="checked" @change="handleProtocolChange">
                  <span>我已阅读并同意</span><router-link :to="{
                    name: 'Provice',
                    params: {
                      name: 'protocol'
                    }
                  }">《用户协议》</router-link>和<router-link :to="{
  name: 'Provice',
  params: {
    name: 'privacy'
  }
}">《隐私政策》</router-link>
                </el-checkbox>
              </div>

              <el-button type="primary" @click="toLogin" @keyup.enter="toLogin">登录</el-button>
              <div class="download">
                <span @click="handleRegister">注册用户</span>
                <span @click="handleForgetPassword">忘记密码</span>
                <span @click="downloadClient">下载客户端</span>
              </div>
              <!-- <img src="../../assets/app_img/btn_login.png" alt=""> -->
            </el-form>
          </div>
          <!-- 扫码登录 -->
          <div v-if="!logFlag" class="codeLogin">
            <div id="qrcode" ref="qrcode"></div>
            <div class="appLog">请使用授课通APP扫二维码登录</div>
          </div>
        </div>
        <span class="version">版本{{
          versions.version_number
        }}&emsp;©深圳睿尚教育科技有限公司&emsp;<a href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank">粤ICP备17121367号</a>
        </span>
      </div>
    </div>
    <!-- 下载客户端弹窗 -->
    <download-client v-if="isShowDownload" :isShowDownload="isShowDownload" :downloadInfo="downloadInfo"
      @closeDownload="closeDownload"></download-client>
  </div>
</template>

<script>
import utils from "../../components/util/index"
import random from "../../components/random"
import QRCode from "qrcodejs2"
import DownloadClient from "./DownloadClient.vue"

export default {
  components: { random, QRCode, DownloadClient },
  data () {
    return {
      downloadUrl: "",
      redownloadUrl: "http://yun.socoton.com/api/uploads/qrcodes/code_app.png", // 初始化加载没有图片使用默认图片
      nowWidth: "500px",
      nowHeight: "",
      color1: "#3e86c7",
      color2: "#999",
      scale: 1,
      form: {},
      logFlag: true,
      username: "",
      password: "",
      yzm: "",
      identifyCodes: "1234567890",
      identifyCode: "",
      link: "http://web.socoton.com/index.php?s=/leartoo/scancode/cate/wlogin/",
      qrcodeId: "",
      qrcodeLink: "",
      showQRcode: false,
      rules: {
        username: [
          { required: false, trigger: "blur" },
          {
            min: 3,
            max: 16,
            message: "长度在 3 到 16 个字符",
            trigger: "blur"
          }
        ],
        password: [{ required: false, trigger: "blur" }]
      },
      checked: true,
      versions: {}, // 版本信息

      isShowDownload: false, // 是否显示下载弹窗
      downloadInfo: {} // 下载信息
    }
  },
  created () {
    // 初始化验证码
    this.refreshCode()
    this.getEeweima()
    this.getSystemInfo()
  },
  mounted () {
    this.nowWidth = `${window.screen.availWidth}` + "px"
    this.nowHeight = `${document.documentElement.clientHeight}` + "px"
    // console.log(this.nowHeight)
    this.userLog()
    this.setScreen()
    this.identifyCode = ""
    this.makeCode(this.identifyCodes, 4)
    window.addEventListener("keydown", this.keyDown)
  },
  // 移除keyup事件
  destroyed () {
    window.removeEventListener("keydown", this.keyDown, false)
  },
  methods: {
    async getEeweima () {
      const res = await this.$axios.get("/public/download/qrcode")
      // console.log(res.data.data.qrcode_url)
      this.downloadUrl = res.data.data.qrcode_url
    },
    userLog () {
      this.logFlag = true
      this.$refs.userLog.style.color = this.color1
      this.$refs.scanLog.style.color = this.color2
      this.showQRcode = false
    },
    scanLog () {
      this.logFlag = !true
      this.$refs.scanLog.style.color = this.color1
      this.$refs.userLog.style.color = this.color2
      if (this.showQRcode == false) {
        // 使用$nextTick确保数据渲染
        this.$nextTick(() => {
          this.qrcode()
        })
      }
      this.showQRcode = true
    },
    // 屏幕适配
    setScreen () {
      let visibleWidth = window.innerWidth
      let visibleHeight = window.innerHeight

      let manualWidth = 1920
      let manualHeight = 1017

      var widthPersentage = (1.0 * visibleWidth) / manualWidth
      var heightPersentage = (1.0 * visibleHeight) / manualHeight

      this.scale = Math.min(widthPersentage, heightPersentage)
    },
    keyDown (e) {
      // 如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.toLogin()
      }
    },
    // 是否勾选同意隐私协议
    handleProtocolChange (e) {
      this.checked = e
    },
    toLogin () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.checked) {
            const { data: res } = await this.$axios.post(
              "/public/login",
              this.form
            )
            if (res.errCode == 0) {
              // console.log(res)
              window.sessionStorage.setItem("token", res.data.token)
              window.localStorage.setItem("class_id", res.data.class_id)
              window.localStorage.setItem("class_name", res.data.class_name)
              window.localStorage.setItem("course_name", res.data.course_name)
              window.localStorage.setItem("depart_id", res.data.depart_id)
              window.localStorage.setItem("name", res.data.name)
              window.localStorage.setItem("username", res.data.username)
              window.localStorage.setItem("photo", res.data.photo)
              window.localStorage.setItem("course_id", res.data.course_id)
              window.localStorage.setItem("cate", res.data.cate)
              window.localStorage.setItem("user_id", res.data.id)
              const date = new Date()
              const strData =
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                date.getDate()
              // console.log(strData)
              window.localStorage.setItem("strData", strData)

              // this.$message.success("登录成功");
              this.$router.push("/banshu")
              this.$store.dispatch("getClassInfo")
              // this.$store.dispatch("getClassInfo");
              // console.log(res.data.token);
            } else {
              this.$message.error(res.message)
            }
          } else {
            this.$message.error("请勾选用户协议与隐私政策")
          }
        } else {
          this.$message.error("登录失败")
        }
      })
    },
    // 注册新用户
    handleRegister () {
      this.$router.push("/register")
    },
    // 忘记密码
    handleForgetPassword () {
      this.$router.push("/findpassword")
    },
    // 验证码
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode () {
      this.identifyCode = ""
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ]
      }
    },

    handleClick (tab, event) {
      console.log(tab, event)
    },
    convertCanvasToImage (canvas) {
      // 从 canvas 提取图片 image      var image = new Image();
      // canvas.toDataURL 返回的是一串Base64编码的URL，当然,浏览器自己肯定支持

      // 指定格式 PNG
      image.src = canvas.toDataURL("image/png")

      return image
    },
    qrcode () {
      let that = this
      that.qrcodeId = new Date().getTime() + Math.round(Math.random() * 10)
      that.qrcodeLink = that.link + "id/" + that.qrcodeId
      // 先清除，后增加
      document.getElementById("qrcode").innerHTML = ""
      let qrcode = new QRCode("qrcode", {
        width: 204,
        height: 204,
        text: that.qrcodeLink,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H
      })
      const timer = setInterval(async () => {
        if (this.showQRcode) {
          const { data: res } = await this.$axios.post("/public/scan/round", {
            code: that.qrcodeId
          })
          if (res.errCode == 0) {
            window.sessionStorage.setItem("token", res.data.token)
            window.localStorage.setItem("class_id", res.data.class_id)
            window.localStorage.setItem("class_name", res.data.class_name)
            window.localStorage.setItem("course_name", res.data.course_name)
            window.localStorage.setItem("depart_id", res.data.depart_id)
            window.localStorage.setItem("name", res.data.name)
            window.localStorage.setItem("username", res.data.username)
            window.localStorage.setItem("photo", res.data.photo)
            window.localStorage.setItem("course_id", res.data.course_id)
            window.localStorage.setItem("cate", res.data.cate)
            const date = new Date()
            const strData =
              date.getFullYear() +
              "-" +
              (date.getMonth() + 1) +
              "-" +
              date.getDate()
            window.localStorage.setItem("strData", strData)

            this.$message.success("登录成功")
            this.$router.push("/banshu")
            // 销毁定时器
            clearInterval(timer)
          }
        } else {
          clearInterval(timer)
        }
      }, 5000)
    },

    // 获取系统信息
    async getSystemInfo () {
      const { data: res } = await this.$axios.get("/public/system/info")
      this.versions = res.data
      const { win_socoton, android, ppt_addin } = res.data
      this.downloadInfo = { win_socoton, android, ppt_addin }
      // console.log(this.downloadInfo)
    },

    // 下载客户端
    downloadClient () {
      this.isShowDownload = true
    },
    closeDownload () {
      this.isShowDownload = false
    }
  },

  watch: {
    // nowWidth:function(newval,oldval){
    //   this.nowWidth = newval
    // },
    // nowHeight:function(newval,oldval){
    //   this.nowWidth = newval
    // },
  }
}
</script>

<style lang="scss" scoped>
.codeLogin>div {
  display: inline-block;
}

.copy {
  margin-top: 40px;
  font-size: 14px;
  color: #888888;
}

.heads {
  display: flex;
  position: absolute;
  top: 60px;
  left: 80px;

  img {
    width: 68px;
    height: 68px;
  }

  span {
    margin-left: 24px;
    line-height: 80px;
    color: #3e86c7;
    font-size: 58px;
    line-height: 68px;
    // height: 80px;
  }
}

.bgimg {
  background-image: url("../../assets/admin_login/bg.jpg");
  background-size: 100% 100%;
  // height: 100%;
  background-size: cover;
  position: relative;
}

.login {
  position: absolute;
  width: 380px;
  height: 100%;
  // border: 1px solid red;
  // z-index: 10000 !important;
  background-color: #fff;
  right: 25px;
  top: 0;
  // left: 61%;
  // top: calc(15.5% - (10px + 5px) * 2);
  // opacity: 0.98;
}

.el-button {
  // margin-left: 46px;
  /* margin-top: 20px; */
  margin-left: 2px;
  width: 240px;
  height: 46px;
  color: #fdfeff;
  border-radius: 30px;
  background-color: #2881cd;
  // box-sizing: border-box;
}

.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.flex_col {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header {
  display: flex;
  // justify-content: space-around;
  margin-left: 95px;
  margin-top: 50px;
  /* background-color: red; */
  height: 40px;
  line-height: 40px;
  color: #999;
  font-size: 18px;

  >div:nth-child(1):hover {
    cursor: default;
    margin-right: 46px;
    border-bottom: 3px solid #3e86c7;
  }

  >div:nth-child(2):hover {
    cursor: default;
    margin-right: 46px;
    border-bottom: 3px solid #3e86c7;
  }

  >div:nth-child(1) {
    margin-right: 46px;
    // border-bottom: 3px solid #3e86c7;
  }

  >div:nth-child(2) {
    margin-right: 46px;
  }
}

.el-form {
  margin-top: 20px;

  img {}
}

.el-input {
  width: 300px;
  height: 46px;
}

.user,
.pwd {
  margin-top: 20px;
}

.code {
  display: flex;
}

.codeInput {
  width: 178px;
  height: 46px;
  margin-left: 40px;
}

.codes {
  width: 100px;
}

.codeLogin {
  width: 100%;

  #qrcode {
    display: block;
    width: 200px;
    height: 200px;
    margin-left: 92px;
    margin-top: 30px;
  }

  >div {
    color: #aeaeae;
    // margin-top: 30px;
    font-size: 14px;
  }

  .appLog {
    margin-top: 15px;
  }
}

.accountLogin {
  margin-top: 40px;

  .protocol {
    margin-top: -16px;
    margin-bottom: 10px;
    font-size: 14px;

    a {
      text-decoration: none;
      color: #409eff;
    }
  }
}

// .accountLogin :nth-of-type(4) {
//   font-size: 14px;
//   width: 100px;
//   margin-left: 256px;
//   margin-top: 17px;
//   color: #999;
// }

/deep/ .el-form-item__label {
  width: 54px !important;
}

/deep/ .el-form-item__content {
  margin-left: 2px !important;
}

.screen {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2084px;
  height: 1018px;
  /* background: url('@/../../../assets/Login/bgimg.jpg') center center no-repeat; */
}

/deep/ .el-form-item__error {
  margin-left: 55px;
}

.downloads {
  position: absolute;
  left: 78px;
  width: 220px;
  height: 100%;

  // background: red;
  img:nth-child(1) {
    margin: 0 auto;
    width: 168px;
    height: 46px;
    display: block;
    margin-top: 39px;
  }

  img:nth-child(2) {
    margin: 0 auto;
    margin-top: 40px;
    display: block;
    width: 180px;
    height: 180px;
  }

  span {
    display: block;
    margin-top: 20px;
    font-size: 14px;
    font-weight: normal;
    color: #1b2422;
  }
}

.indexs {
  // border: 1px solid red;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 800px;
  height: 400px;
  margin: auto;

  .xian {
    height: 243px;
    width: 1px;
    position: absolute;
    background: #e5e8eb;
    top: 110px;
    left: 45%;
  }

  .version {
    position: absolute;
    bottom: 15px;
    // left: 42%;
    left: 25%;
    font-size: 14px;
    color: #b3c0d1;
    z-index: 1;

    a {
      color: #b3c0d1;
      text-decoration: none;
      cursor: pointer;
    }
  }
}

/deep/ .el-input__icon {
  color: #92b7d6;
  font-size: 20px;
  margin-right: 17px !important;
}

/deep/ .el-input__inner {
  padding-left: 36px;
}

.codeInput /deep/ .el-input__inner {
  padding-left: 16px;
}

// 下载客户端
.download {
  margin-top: 12px;
  margin-left: -30px;
  font-size: 14px;
  color: #999;
  cursor: pointer;

  &>span:hover {
    &:hover {
      color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Login/index.vue